import getGeo from '../glb/geo';

export default function () {
    return {
        geo: getGeo(),
        managementMembers: [],
        brokerageInfo: {},
    };
}
